import FilterOperator from "@mapmycustomers/shared/enum/FilterOperator";
import { AreaFilterCondition } from "@mapmycustomers/shared/types/viewModel/internalModel/FilterModel";
import { AreaCondition } from "@mapmycustomers/shared/types/viewModel/platformModel/PlatformFilterModel";

import { METERS_IN_MILE } from "@app/util/consts";
import { isEntityAreaCondition } from "@app/util/viewModel/converters/utils/asserts";

const units: Record<string, "km" | "m" | "mi"> = {
  km: "km",
  meter: "m",
  mi: "mi",
};

const parseAreaCondition = (platformCondition: AreaCondition): AreaFilterCondition => {
  const unit = units[platformCondition.uom?.toLowerCase() ?? "meter"] ?? "m";
  const distanceInMeters =
    unit === "km"
      ? platformCondition.radius * 1000
      : unit === "mi"
        ? METERS_IN_MILE * platformCondition.radius
        : platformCondition.radius;

  if (isEntityAreaCondition(platformCondition)) {
    return {
      operator: FilterOperator.IN_AREA,
      value: { distanceInMeters, entity: platformCondition.entity },
    };
  } else {
    const [longitude, latitude] = platformCondition.point;

    return {
      operator: FilterOperator.IN_AREA,
      value: { distanceInMeters, latitude, location: platformCondition.location ?? "", longitude },
    };
  }
};

export default parseAreaCondition;
